export default __webpack_public_path__ + "static/media/logo-finanzas.0f2286b6.png";